"use client";

import { Button } from "@/components/ui/button";

// Shared body for the error boundaries (root and (console)). Copy stays
// page-agnostic: each boundary covers many routes.
export function ErrorScreen({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  // Next's retry = refresh router state, then reset the boundary — the
  // fuller recovery of the two callbacks error.tsx receives.
  retry: () => void;
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-4 text-center">
      <h2 className="font-semibold text-sm">Something went wrong</h2>
      {process.env.NODE_ENV === "development" ? (
        <p className="max-w-sm font-mono text-muted-foreground text-xs">{error.message}</p>
      ) : (
        // In production Next redacts server error messages; the digest is the
        // piece that correlates with the server logs.
        <>
          <p className="max-w-sm text-muted-foreground text-sm">
            Something broke on our side. Try again in a moment.
          </p>
          {error.digest && (
            <p className="font-mono text-muted-foreground text-xs">Reference: {error.digest}</p>
          )}
        </>
      )}
      <Button variant="outline" size="sm" onClick={retry}>
        Try again
      </Button>
    </div>
  );
}
